(() => {
  const STORAGE_KEY = 'mcl-wishlist';

  function getWishlist() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

      if (!Array.isArray(stored)) {
        return [];
      }

      return [...new Set(stored.filter(Boolean))];
    } catch (error) {
      console.warn('Meine Lounge konnte nicht gelesen werden.', error);
      return [];
    }
  }

  function saveWishlist(items) {
    const cleanItems = [...new Set(items.filter(Boolean))];

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cleanItems));
    } catch (error) {
      console.warn('Meine Lounge konnte nicht gespeichert werden.', error);
    }

    updateButtons();

    document.dispatchEvent(
      new CustomEvent('mcl:wishlist:change', {
        detail: {
          items: cleanItems,
          count: cleanItems.length
        }
      })
    );

    return cleanItems;
  }

  function hasItem(handle) {
    return getWishlist().includes(handle);
  }

  function addItem(handle) {
    if (!handle) return getWishlist();

    const items = getWishlist();

    if (!items.includes(handle)) {
      items.push(handle);
    }

    return saveWishlist(items);
  }

  function removeItem(handle) {
    if (!handle) return getWishlist();

    return saveWishlist(
      getWishlist().filter((item) => item !== handle)
    );
  }

  function toggleItem(handle) {
    if (!handle) return false;

    if (hasItem(handle)) {
      removeItem(handle);
      return false;
    }

    addItem(handle);
    return true;
  }

  function updateButtons() {
    document
      .querySelectorAll('[data-mcl-wishlist-toggle]')
      .forEach((button) => {
        const handle = button.dataset.productHandle;
        const active = hasItem(handle);

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const label = active
          ? 'Aus Meine Lounge entfernen'
          : 'In Meine Lounge speichern';

        button.setAttribute('aria-label', label);

        const text = button.querySelector('[data-mcl-wishlist-label]');

        if (text) {
          text.textContent = label;
        }
      });
          
    
    const hasLoungeItems = getWishlist().length > 0;

    document.querySelectorAll('.mcl-menu-heart').forEach((heart) => {
      heart.classList.toggle('is-active', hasLoungeItems);
    });
  }
  

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mcl-wishlist-toggle]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;

    if (!handle) return;

    toggleItem(handle);
  });

  document.addEventListener('DOMContentLoaded', updateButtons);

  window.MCLWishlist = {
    get: getWishlist,
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    has: hasItem,
    count: () => getWishlist().length,
    refresh: updateButtons
  };
})();